import React, { useEffect, useState } from 'react';
import { message, Modal } from 'antd';
import { PhoneOutlined } from '@ant-design/icons';
import { PhoneInput } from 'react-international-phone';
import useDashboard from '../../../../../base/hooks/appointmentManagement/dashboard/useDashboard';
import './securityHotline.scss';

const SecurityHotline = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [phone, setPhone] = useState('');
    const [originalPhone, setOriginalPhone] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const { getPhone, updatePhone } = useDashboard();
    useEffect(() => {
        loadSecurityPhone();
    }, []);
    const handleClose = () => {
        setIsModalOpen(false);
        setPhone(originalPhone);
    };

    const loadSecurityPhone = async () => {
        const res = await getPhone({});
        const securityPhone = res.phone?.trim() || '';
        if (securityPhone) {
            setPhone(securityPhone);
            setOriginalPhone(securityPhone);
        }
    };
    const handleSave = async () => {
        setIsSubmitting(true);
        const normalizedPhone = phone.trim();
        if (!normalizedPhone || isSubmitting) {
            return;
        }
        const response = await updatePhone({
            phone:normalizedPhone
        });
        if (response.success) {
            messageApi.success(response.message || 'Security hotline updated successfully');
            setOriginalPhone(normalizedPhone);
            setIsModalOpen(false);
            setTimeout(()=>{
                setIsSubmitting(false);
            },800)
        } else {
            setTimeout(()=>{
                setIsSubmitting(false);
            },800)
            messageApi.error(response.message || 'Failed to update security hotline');
        }
};

    return (
        <>
            <button
                type="button"
                className="security-hotline-trigger"
                aria-label="Edit security hotline"
                onClick={() => setIsModalOpen(true)}
            >
                <PhoneOutlined />
            </button>

            <Modal
                open={isModalOpen}
                title="Edit Security Hotline"
                footer={null}
                width={540}
                centered
                destroyOnClose
                className="security-hotline-modal"
                styles={{ mask: { backgroundColor: 'rgba(0, 0, 0, 0.5)' } }}
                closeIcon={<img src={require('../../../../../assets/icons/model_close.png')} alt="Close" />}
                onCancel={handleClose}
            >
                <div className="security-hotline-form">
                    <PhoneInput
                        defaultCountry="cn"
                        value={phone}
                        onChange={setPhone}
                        hideDropdown
                        disabled={isLoading || isSubmitting}
                        className="security-hotline-phone-input"
                        inputProps={{ className: 'security-hotline-number-input' }}
                    />
                    <button
                        type="button"
                        className={`security-hotline-save ${!phone.trim() || isSubmitting ? 'disabled' : ''}`}
                        disabled={!phone.trim() || isSubmitting}
                        onClick={handleSave}
                    >
                        {isSubmitting ? 'Saving...' : 'Save'}
                    </button>
                </div>
            </Modal>
            {contextHolder}
        </>
    );
};

export default SecurityHotline;
